'use client'

import { useCallback } from 'react'
import { useProductStore } from '@/stores/useProductStore'

/**
 * Quantidade escolhida na PDP (mínimo 1), compartilhada pelo seletor, pelo botão de comprar e pelo frete. `reset`
 * volta para 1 depois de adicionar ao carrinho, como a loja sempre fez.
 */
export function useProductQuantity() {
    const quantity = useProductStore((state) => state.quantity)
    const setProductQuantity = useProductStore((state) => state.setProductQuantity)

    const increment = useCallback(
        () => setProductQuantity(useProductStore.getState().quantity + 1),
        [setProductQuantity],
    )
    const decrement = useCallback(
        () => setProductQuantity(useProductStore.getState().quantity - 1),
        [setProductQuantity],
    )
    const reset = useCallback(() => setProductQuantity(1), [setProductQuantity])

    return { quantity, increment, decrement, reset }
}
